import { Pagination, Skeleton } from "@mui/material";
import {
  PowerIcon,
  PowerOffIcon,
  Repeat,
  Repeat1,
  Settings2Icon,
  UserRoundCogIcon,
} from "lucide-react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { checkTagValidity } from "../../Utils/Utils";
import {
  CHARGER_LISTE_UTILISATEUR,
  DISABLE_USER,
  REACTIVATION_USER,
  RESET_PASSWORD,
} from "../../Utils/constant";
import EditPenIcon from "../../assets/icons/pen.svg";
import model from "../../assets/model-fichier/Model_users.xlsx";
import { UploadButton } from "../../components/Widget/UploadButton";
import { AddUser } from "../../components/utilisateur/AddUserSidebar";
import { EditPassword } from "../../components/utilisateur/EditPassword";
import { EditProfil } from "../../components/utilisateur/EditProfil";
import { EditerUtilisateur } from "../../components/utilisateur/EditerUtilisateur";
import { deleteOne, disable } from "../../services/service";
import { useRoleStore } from "../../store/RoleStore";
import { useStoreUser } from "../../store/user";

const Utilisateurs = () => {
  const users = useStoreUser();
  const role = useRoleStore();
  const loading = users.loading;
  const [selectItem, setSelectItem] = useState(null);

  useEffect(() => {
    users.user({ page: 0, param: "", size: 10 }, `&role=`);
    role.getData("page=0&param=&size=1000008&typeProfile=");
  }, []);

  const more = async (page) => {
    users.user({ page: page - 1, param: "", size: 10 }, `&role=`);
  };

  const handleReset = (id) => {
    deleteOne(RESET_PASSWORD, id)
      .then(() => {
        users.user({ page: 0, param: "", size: 10 });
        toast.success("Compteur utilisateur rénitialisé");
      })
      .catch((err) => {
        toast.error(err.response.data.donnee);
      });
  };

  const columns = [
    {
      name: "Nom et prenoms",
    },
    {
      name: "Nom d'utilisateur",
    },
    {
      name: "Email",
    },
    {
      name: "Numero telephone",
    },
    {
      name: "Role",
    },
    {
      name: "Superviseur",
    },
    {
      name: "Date creation",
    },
    {
      name: "Date connexion",
    },
    {
      name: "Etat du compte",
    },
    {
      name: "Statut du compte",
    },
    {
      name: "Action",
    },
  ];

  return (
    <>
      {checkTagValidity("LISTE_UTILISATEURS") ? (
        <>
          <div className="flex item-center">
            <h1 className="text-3xl font-mtn font-extrabold text-black">
              Utilisateurs
            </h1>
            <div className="ml-auto">
              <div className="flex items-center gap-1">
                <UploadButton
                  uploadUrl={CHARGER_LISTE_UTILISATEUR}
                  fetchData={() => {
                    users.user({ page: 0, param: "", size: 10 }, `&role=`);
                  }}
                  model={model}
                />
                {checkTagValidity("AJOUTER_UTILISATEUR") ? (
                  <button
                    onClick={() =>
                      document.getElementById("add_user").showModal()
                    }
                    className="btn btn-sm bg-main rounded-md text-black text-xs hover:bg-gray-900 hover:text-white"
                  >
                    Ajouter un utilisateur
                  </button>
                ) : null}
              </div>

              <dialog id="add_user" className="modal rounded-none">
                <div className="modal-box w-10/12 max-w-2xl">
                  <div className="modal-action">
                    <form method="dialog">
                      <button
                        id="fermer-modal"
                        className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                      >
                        ✕
                      </button>
                    </form>
                  </div>
                  <AddUser />
                </div>
              </dialog>

              <dialog id="edit_user" className="modal rounded-none">
                <div className="modal-box w-10/12 max-w-2xl">
                  <div className="modal-action">
                    <form method="dialog">
                      <button
                        id={`fermer-modal${selectItem?.id}`}
                        className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                      >
                        ✕
                      </button>
                    </form>
                  </div>
                  <EditerUtilisateur item={selectItem} />
                </div>
              </dialog>

              <dialog id="edit_password" className="modal rounded-none">
                <div className="modal-box w-10/12 max-w-xl">
                  <div className="modal-action">
                    <h1 className="mr-auto text-2xl font-bold font-mtn">
                      Modifier le mot de passe de l'utilisateur
                    </h1>
                    <form method="dialog">
                      <button
                        id={`fermer-modal${selectItem?.username}`}
                        className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                      >
                        ✕
                      </button>
                    </form>
                  </div>
                  <EditPassword username={selectItem?.username} />
                </div>
              </dialog>

              <dialog id="edit_profil" className="modal rounded-none">
                <div className="modal-box w-10/12 max-w-xl">
                  <div className="modal-action">
                    <h1 className="mr-auto text-2xl font-bold font-mtn">
                      Modifier le profil
                    </h1>
                    <form method="dialog">
                      <button
                        id={`fermer-profile${selectItem?.id}`}
                        className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                      >
                        ✕
                      </button>
                    </form>
                  </div>

                  <EditProfil item={selectItem} />
                </div>
              </dialog>
            </div>
          </div>

          <div className="mt-12 bg-white rounded-lg p-3 border border-[#f2f5fa] ">
            <div className="lg:flex gap-1 items-center">
              <input
                onChange={(e) => {
                  users.user(
                    { page: 0, param: e.target.value, size: 10 },
                    `&role=`
                  );
                }}
                type="text"
                placeholder="Recherche..."
                className="input input-bordered px-3 my-2 w-80 h-10 text-gray-900 placeholder:text-gray-400"
              />
              <select
                onChange={(e) => {
                  users.user(
                    { page: 0, param: "", size: 10 },
                    `&role=${encodeURIComponent(e.target.value)}`
                  );
                }}
                className="my-2 select capitalize"
              >
                <option value="">Tout</option>
                {role?.data?.data?.map((item) => (
                  <option value={item.id}>
                    {item.id
                      .replace(/ROLE_/g, " ")
                      .replace(/_/g, " ")
                      .toLowerCase()}
                  </option>
                ))}
              </select>
            </div>
            {/* Version Desktop - Scroll horizontal contrôlé */}
            <div className="hidden xl:block border rounded-lg lg:w-[1024px] xl:w-[1050px] 2xl:w-[1150px] overflow-auto">
              <table className="table table-zebra w-full">
                <thead className="bg-main text-black font-mtn">
                  <tr>
                    {columns.map((item, index) => (
                      <th
                        key={index}
                        className="text-xs whitespace-nowrap px-3 py-3"
                      >
                        {item.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="text-xs">
                  {users?.data?.users?.length === 0 ? (
                    <tr>
                      <td colSpan={columns.length} className="text-center py-8">
                        Aucune donnée
                      </td>
                    </tr>
                  ) : users?.data?.users?.length !== 0 && !loading ? (
                    users?.data?.users?.map((item, index) => (
                      <tr key={index}>
                        <td className="px-3 py-3" style={{ minWidth: "120px" }}>
                          {item.nomPrenoms}
                        </td>
                        <td className="px-3 py-3" style={{ minWidth: "120px" }}>
                          {item.username}
                        </td>
                        <td className="px-3 py-3" style={{ minWidth: "180px" }}>
                          {item.email}
                        </td>
                        <td className="px-3 py-3" style={{ minWidth: "120px" }}>
                          {item.numero}
                        </td>
                        <td className="px-3 py-3" style={{ minWidth: "100px" }}>
                          <span
                            className={`capitalize text-xs inline-block truncate ${
                              item?.roles[0] === "ROLE_ADMIN"
                                ? "bg-green-100 text-green-800 "
                                : "bg-slate-900 text-white"
                            } rounded-lg px-2 py-1`}
                          >
                            {item?.roles[0]
                              ?.replace(/ROLE_/g, " ")
                              .replace(/_/g, " ")
                              .toLowerCase()}
                          </span>
                        </td>
                        <td className="px-3 py-3" style={{ minWidth: "120px" }}>
                          {item?.superviseur?.nomPrenoms ?? "--"}
                        </td>
                        <td className="px-3 py-3" style={{ minWidth: "150px" }}>
                          {item.dateCreation
                            ? new Date(item?.dateCreation).toLocaleString()
                            : "--"}
                        </td>
                        <td className="px-3 py-3" style={{ minWidth: "150px" }}>
                          {item.dateConnexion
                            ? new Date(item?.dateConnexion).toLocaleString()
                            : "--"}
                        </td>
                        <td className="px-3 py-3" style={{ minWidth: "80px" }}>
                          <span
                            className={`text-xs inline-block ${
                              item?.enabled
                                ? "bg-green-100 text-green-800 font-semibold"
                                : "bg-rose-100 text-rose-800 font-semibold"
                            } rounded-lg px-2 py-1`}
                          >
                            {item?.enabled ? "Actif" : "Inactif"}
                          </span>
                        </td>
                        <td className="px-3 py-3" style={{ minWidth: "80px" }}>
                          <span
                            className={`text-xs inline-block ${
                              item?.statutCompte === "ACTIF"
                                ? "bg-green-100 text-green-800 font-semibold"
                                : "bg-rose-100 text-rose-800 font-semibold"
                            } rounded-lg px-2 py-1`}
                          >
                            {item?.statutCompte.toLowerCase()}
                          </span>
                        </td>
                        <td className="px-3 py-3" style={{ minWidth: "180px" }}>
                          <div className="flex items-center gap-x-2">
                            {checkTagValidity("MODIFIER_MOT_DE_PASSE") ? (
                              <div
                                className="tooltip font-mtn"
                                data-tip="Modifier le mot de passe"
                              >
                                <button
                                  onClick={() => {
                                    setSelectItem(item);
                                    document
                                      .getElementById("edit_password")
                                      .showModal();
                                  }}
                                  className="w-7 h-7 rounded-lg bg-main flex items-center justify-center"
                                >
                                  <UserRoundCogIcon size={15} />
                                </button>
                              </div>
                            ) : null}

                            <div className="tooltip" data-tip="Modifier">
                              <button
                                onClick={() => {
                                  setSelectItem(item);
                                  document
                                    .getElementById("edit_user")
                                    .showModal();
                                }}
                                className="w-7 h-7 rounded-lg bg-main flex items-center justify-center"
                              >
                                <img
                                  src={EditPenIcon}
                                  alt="icon"
                                  className="w-4"
                                />
                              </button>
                            </div>

                            <button
                              onClick={() => {
                                document.getElementById("disable").showModal();
                                setSelectItem(item);
                              }}
                              className="w-7 h-7 rounded-lg bg-red-100 flex items-center justify-center"
                            >
                              {item?.enabled ? (
                                <PowerOffIcon size={14} />
                              ) : (
                                <PowerIcon size={14} />
                              )}
                            </button>

                            {item?.statutCompte === "DORMANT" ? (
                              <div className="tooltip" data-tip="Reactivation">
                                <button
                                  onClick={() => {
                                    document
                                      .getElementById("reactivation")
                                      .showModal();
                                    setSelectItem(item);
                                  }}
                                  className="w-7 h-7 rounded-lg bg-red-100 flex items-center justify-center"
                                >
                                  <Repeat size={14} />
                                </button>
                              </div>
                            ) : null}

                            <div
                              className="tooltip font-mtn"
                              data-tip="Editer le profil"
                            >
                              <button
                                onClick={() => {
                                  setSelectItem(item);
                                  document
                                    .getElementById("edit_profil")
                                    .showModal();
                                }}
                                className="w-7 h-7 rounded-lg bg-main flex items-center justify-center"
                              >
                                <Settings2Icon size={15} />
                              </button>
                            </div>

                            <div
                              className="tooltip font-mtn"
                              data-tip="Renitialiser le compte"
                            >
                              <button
                                onClick={() => handleReset(item?.id)}
                                className="w-7 h-7 rounded-lg bg-main flex items-center justify-center"
                              >
                                <Repeat1 size={15} />
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    [1, 2, 3, 4, 5].map((item) => (
                      <tr key={item}>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((col) => (
                          <td key={col} className="px-3 py-3">
                            <Skeleton height={13} />
                          </td>
                        ))}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Version Tablet/Mobile */}
            <div className="xl:hidden space-y-4">
              {users?.data?.users?.length === 0 ? (
                <div className="text-center py-8 border rounded-lg">
                  <p className="text-gray-500">Aucune donnée</p>
                </div>
              ) : users?.data?.users?.length !== 0 && !loading ? (
                users?.data?.users?.map((item, index) => (
                  <div
                    key={index}
                    className="bg-white border rounded-lg p-4 shadow-sm"
                  >
                    <div className="flex flex-col space-y-3">
                      {/* Header avec nom et actions */}
                      <div className="flex justify-between items-start">
                        <div>
                          <h3 className="font-semibold text-sm">
                            {item.nomPrenoms}
                          </h3>
                          <p className="text-xs text-gray-600">
                            {item.username}
                          </p>
                        </div>
                        <div className="flex items-center gap-x-2">
                          {checkTagValidity("MODIFIER_MOT_DE_PASSE") ? (
                            <button
                              onClick={() => {
                                setSelectItem(item);
                                document
                                  .getElementById("edit_password")
                                  .showModal();
                              }}
                              className="w-8 h-8 rounded-lg bg-main flex items-center justify-center"
                            >
                              <UserRoundCogIcon size={16} />
                            </button>
                          ) : null}

                          <button
                            onClick={() => {
                              setSelectItem(item);
                              document.getElementById("edit_user").showModal();
                            }}
                            className="w-8 h-8 rounded-lg bg-main flex items-center justify-center"
                          >
                            <img src={EditPenIcon} alt="icon" className="w-4" />
                          </button>

                          <button
                            onClick={() => {
                              document.getElementById("disable").showModal();
                              setSelectItem(item);
                            }}
                            className="w-8 h-8 rounded-lg bg-red-100 flex items-center justify-center"
                          >
                            {item?.enabled ? (
                              <PowerOffIcon size={16} />
                            ) : (
                              <PowerIcon size={16} />
                            )}
                          </button>

                          <button
                            onClick={() => {
                              setSelectItem(item);
                              document
                                .getElementById("edit_profil")
                                .showModal();
                            }}
                            className="w-8 h-8 rounded-lg bg-main flex items-center justify-center"
                          >
                            <Settings2Icon size={16} />
                          </button>
                        </div>
                      </div>

                      {/* Informations principales */}
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs">
                        <div>
                          <span className="text-gray-500">Email:</span>
                          <p className="font-medium truncate">{item.email}</p>
                        </div>
                        <div>
                          <span className="text-gray-500">Numéro:</span>
                          <p className="font-medium">{item.numero}</p>
                        </div>
                      </div>

                      {/* Status badges */}
                      <div className="flex flex-wrap gap-2">
                        <span
                          className={`text-xs inline-block ${
                            item?.roles[0] === "ROLE_ADMIN"
                              ? "bg-green-100 text-green-800 font-semibold"
                              : "bg-rose-100 text-rose-800 font-semibold"
                          } rounded-lg px-2 py-1`}
                        >
                          {item?.roles[0]?.toLowerCase().replace(/role_/g, " ")}
                        </span>

                        <span
                          className={`text-xs inline-block ${
                            item?.enabled
                              ? "bg-green-100 text-green-800 font-semibold"
                              : "bg-rose-100 text-rose-800 font-semibold"
                          } rounded-lg px-2 py-1`}
                        >
                          {item?.enabled ? "Actif" : "Inactif"}
                        </span>

                        <span
                          className={`text-xs inline-block ${
                            item?.statutCompte === "ACTIF"
                              ? "bg-green-100 text-green-800 font-semibold"
                              : "bg-rose-100 text-rose-800 font-semibold"
                          } rounded-lg px-2 py-1`}
                        >
                          {item?.statutCompte.toLowerCase()}
                        </span>
                      </div>

                      {/* Date de connexion */}
                      <div className="text-xs">
                        <span className="text-gray-500">
                          Dernière connexion:
                        </span>
                        <p className="font-medium">
                          {item.dateConnexion
                            ? new Date(item?.dateConnexion).toLocaleString()
                            : "--"}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                [1, 2, 3, 4, 5].map((item) => (
                  <div key={item} className="bg-white border rounded-lg p-4">
                    <div className="space-y-3">
                      <Skeleton height={20} />
                      <Skeleton height={15} />
                      <Skeleton height={15} />
                    </div>
                  </div>
                ))
              )}
            </div>

            {/* Modal (reste identique) */}
            <dialog id="disable" className="modal">
              <div className="modal-box max-w-md rounded-lg">
                <h3 className="font-extrabold text-xl text-red-600">
                  Attention
                </h3>
                <p className="pt-2 text-black font-medium">
                  Voulez vous vraiment effectuer cette action ?
                </p>
                <div className="modal-action">
                  <form
                    method="dialog"
                    className="w-full flex items-center justify-end gap-x-4"
                  >
                    <button className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                      Annuler
                    </button>
                    <button
                      onClick={() => {
                        disable(DISABLE_USER, selectItem.id)
                          .then((res) => {
                            toast.success(
                              `Utilisateur ${
                                selectItem?.enabled ? "Désactiver" : "Activer"
                              }`
                            );
                            users.user(
                              { page: 0, param: "", size: 10 },
                              `&role=`
                            );
                          })
                          .catch((err) => {});
                      }}
                      className="bg-black text-white w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold"
                    >
                      {selectItem?.enabled ? "Désactiver" : "Activer"}
                    </button>
                  </form>
                </div>
              </div>
            </dialog>

            <dialog id="reactivation" className="modal">
              <div className="modal-box max-w-md rounded-lg">
                <h3 className="font-extrabold text-xl text-red-600">
                  Attention
                </h3>
                <p className="pt-2 text-black font-medium">
                  Voulez vous vraiment effectuer cette action ?
                </p>
                <div className="modal-action">
                  <form
                    method="dialog"
                    className="w-full flex items-center justify-end gap-x-4"
                  >
                    <button className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                      Annuler
                    </button>
                    <button
                      onClick={() => {
                        disable(REACTIVATION_USER, selectItem.id)
                          .then((res) => {
                            toast.success("Operation effectuée avec succès !");
                            users.user(
                              { page: 0, param: "", size: 10 },
                              `&role=`
                            );
                          })
                          .catch((err) => {});
                      }}
                      className="bg-black text-white w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold"
                    >
                      {selectItem?.enabled ? "Désactiver" : "Activer"}
                    </button>
                  </form>
                </div>
              </div>
            </dialog>
          </div>
        </>
      ) : null}
      <div className="my-3 flex justify-end">
        <Pagination
          onChange={(event, newValue) => more(newValue)}
          onSelect={(selectedPage) => more(selectedPage)}
          count={users?.data?.totalPages}
          variant="outlined"
          color="primary"
          shape="rounded"
        />
      </div>
    </>
  );
};

export default Utilisateurs;
